import React from "react";
import { ENQUIRY_DATE_RANGE_PRESETS } from "./enquiry-settings";
import type { EnquiryDateRangeFilter, EnquiryDateRangePreset } from "./enquiry-date-range";

type EnquiryDateRangeFilterProps = {
    value: EnquiryDateRangeFilter;
    onChange: (value: EnquiryDateRangeFilter) => void;
};

const chipClass = (active: boolean) =>
    active
        ? "border-gray-900 bg-gray-900 text-white"
        : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50";

const dateInputClass =
    "h-9 rounded-lg border border-gray-200 px-2.5 text-sm text-gray-800 focus:border-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-200";

export const EnquiryDateRangeFilterBar = ({ value, onChange }: EnquiryDateRangeFilterProps) => {
    const showCustom = value.preset === "custom" || Boolean(value.from || value.to);

    const setPreset = (preset: EnquiryDateRangePreset) => {
        if (preset === "custom") {
            onChange({ ...value, preset: "custom" });
            return;
        }
        onChange({ preset, from: "", to: "" });
    };

    return (
        <div>
            <p className="mb-2 text-xs font-medium text-gray-500">Date range</p>
            <div className="flex flex-wrap gap-2">
                {ENQUIRY_DATE_RANGE_PRESETS.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => setPreset(option.value)}
                        className={`rounded-lg border px-3 py-1.5 text-sm font-medium transition ${chipClass(value.preset === option.value)}`}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            {showCustom ? (
                <div className="mt-2 flex flex-wrap items-center gap-2">
                    <input
                        type="date"
                        value={value.from}
                        onChange={(event) =>
                            onChange({ preset: "custom", from: event.target.value, to: value.to })
                        }
                        className={dateInputClass}
                    />
                    <span className="text-sm text-gray-400">to</span>
                    <input
                        type="date"
                        value={value.to}
                        min={value.from || undefined}
                        onChange={(event) =>
                            onChange({ preset: "custom", from: value.from, to: event.target.value })
                        }
                        className={dateInputClass}
                    />
                </div>
            ) : null}
        </div>
    );
};
